import { render, staticRenderFns } from "./InicioComandero.vue?vue&type=template&id=765b78b4"
import script from "./InicioComandero.vue?vue&type=script&lang=js"
export * from "./InicioComandero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports